<template>
  <Modal :id="'cmp-contacts-import_export-merge_contact'" @cancelled="onCancel">
    <template slot="header">MERGE CONTACT</template>

    <template slot="body">
      <div class="contact-type-selection">
        <div class="contact-type">
          <input
            type="radio"
            :checked="searchStringField == 'company_name'"
            @change="(e) => onSearchFieldCheckboxChange(e, 'company_name')"
            name="cb_company_name"
            id="cb_company_name"
          />
          <label
            for="contact"
            @click="(e) => onSearchFieldCheckboxChange(e, 'company_name')"
            >{{ $t("company_name") }}</label
          >
        </div>
        <div class="contact-type">
          <input
            type="radio"
            :checked="searchStringField == 'last_name'"
            @change="(e) => onSearchFieldCheckboxChange(e, 'last_name')"
            name="cb_last_name"
            id="cb_last_name"
          />
          <label
            for="contact"
            @click="(e) => onSearchFieldCheckboxChange(e, 'last_name')"
            >{{ $t("last_name") }}</label
          >
        </div>
        <div class="contact-type">
          <input
            type="radio"
            :checked="searchStringField == 'email1'"
            @change="(e) => onSearchFieldCheckboxChange(e, 'email1')"
            name="cb_last_name"
            id="cb_last_name"
          />
          <label
            for="contact"
            @click="(e) => onSearchFieldCheckboxChange(e, 'email1')"
            >{{ $t("email") }}</label
          >
        </div>
      </div>
      <div class="fform-group">
        <SearchList
          :showSelectAll="false"
          :id="'contact_id'"
          :items="contacts"
          :keyProperty="'contact_id'"
          :label="'contact_computed_name'"
          :placeholder="'Search'"
          @searched="onSearchInputKeyup"
          :selected="selectedContacts"
          @selected="onContactSelected"
          :disabledFunc="contactDisabledFunc"
        />
        <div
          v-if="selectedContacts && selectedContacts.size == 2"
          style="margin-top: 10px; color: var(--text-accent)"
        >
          {{ $t("only_2_contacts_can_be_selected") }}
        </div>

        <!-- @searched="onArtistsSearched"
          @selected="onContactSelected" -->
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        class="dt-button v1 s6"
        @click.stop="onClickOK"
        :disabled="selectedContactsLength != 2"
      >
        {{ $t("ok") }}
      </button>
      <!-- <button
        v-if="trackType == 'existing'"
        class="dt-button v1"
        @click.stop="addNewTrack"
        :class="{ disabled: !isExistingFormValid }"
        :disabled="!isExistingFormValid"
      >
        OK
      </button>
      <button
        v-if="trackType == 'new'"
        class="dt-button v1"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="addNewTrack"
      >
        OK
      </button> -->
    </template>
  </Modal>

  <!-- <v-dialog v-model="isCompareModal" persistent width="850">
      <CompareModal
        :modal-data="compareModalData"
        @cancelled="onCancelledCompareModal()"
        @finished="onFinishedMergeCompare()"
      />
    </v-dialog> -->
</template>

<script>
import InputField from "@plugins/text-field/input-field";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet } from "../../../../utility";
import { ContactIMEXService } from "../../services/contact_import_export.service";
import CompareModal from "./merge-contact-compare-modal";
import Modal from "@/dt-plugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
export default {
  components: {
    InputField,
    CompareModal,
    Modal,
    SearchList,
  },
  data: function () {
    return {
      subjectSearchSubject$: new Subject(),
      searchString: "",
      searchStringField: "",
      contacts: [],
      selectedContacts: new Set(),
      isCompareModal: false,
      compareModalData: {},
    };
  },
  mounted: function () {
    this.$subscribeTo(
      this.subjectSearchSubject$
        .asObservable()
        .pipe(distinctUntilChanged(), debounceTime(500)),
      (searchString) => {
        this.selectedContacts = new Set();
        console.log({
          "merge-contact-modal.vue:146 this.selectedContacts":
            this.selectedContacts,
        });
        if (searchString.length > 0) {
          ContactIMEXService.getSearch(searchString).then((res) => {
            this.setContacts(res.data.contacts);
            // this.searchStringField = "";
          });
        } else {
          this.contacts = [];
        }
      }
    );
  },
  watch: {},
  computed: {
    selectedContactsLength: function () {
      return Array.from(this.selectedContacts).length;
    },
    contactDisabledFunc() {
      return (contact) => {
        console.log("this.selectedContacts", this.selectedContacts);
        return (
          !this.selectedContacts.has(contact.contact_id) &&
          this.selectedContacts.size == 2
        );
      };
    },
  },
  methods: {
    onCancel() {
      this.$emit("cancelled");
    },

    async onClickOK() {
      let selectedContacts = Array.from(this.selectedContacts);
      this.selectedContactIDs = selectedContacts.join();
      //const res = await ContactIMEXService.getMergeModalData(selectedContacts.join())
      // .then(
      //   (res) => {
      //     this.compareModalData = res.data;
      //   }
      // );
      //this.onOpenCompareModal();
      //this.compareModalData = res.data;
      //console.log("this.compareModalData",this.compareModalData)
      this.onOpenCompareModal();
    },

    onSearchFieldCheckboxChange: function (e, fieldValue) {
      this.searchStringField = fieldValue;
      ContactIMEXService.getFieldSearch(this.searchStringField).then((res) => {
        this.setContacts(res.data.contacts);
        this.searchString = "";
      });
    },
    onContactSelected: function (selectedContacts) {
      // let size = selectedContacts.size;
      // if (size <= 2) {
      //   }
      this.selectedContacts = selectedContacts;
    },
    onSearchInputKeyup: function (event) {
      console.log(event, ":::::::::::");
      //this.searchString = event.target.value;
      this.subjectSearchSubject$.next(event);
    },
    onArtistItemClick: function (e, contact) {
      let size = this.selectedContacts.size;
      if (
        (size == 2 && this.selectedContacts.has(contact.contact_id)) ||
        size < 2
      ) {
        this.selectedContacts = addRemoveSet(
          "toggle",
          this.selectedContacts,
          contact.contact_id
        );
      } else {
        e.target.checked = false;
      }
    },
    setContacts(contacts) {
      this.selectedContacts = new Set();

      this.contacts = contacts.map((contact) => {
        var address1 =
          contact.address1 != "" &&
          contact.address1 != null &&
          typeof contact.address1 != "undefined"
            ? ", " + contact.address1
            : "";
        var city =
          contact.city != "" &&
          contact.city != null &&
          typeof contact.city != "undefined"
            ? ", " + contact.city
            : "";
        var country =
          contact.country != "" &&
          contact.country != null &&
          typeof contact.city != "undefined"
            ? ", " + contact.country
            : "";
        contact.contact_computed_name = "";
        contact.contact_computed_name =
          contact.company_name != "" && contact.company_name != null
            ? contact.company_name || contact.company_legalname
            : contact.first_name + " " + contact.last_name;

        contact.contact_computed_name =
          contact.contact_computed_name + address1 + city + country;

        return contact;
      });
    },
    onCancelledCompareModal() {
      this.isCompareModal = false;
    },
    onOpenCompareModal() {
      //this.isCompareModal = true;
      let selectedContacts = Array.from(this.selectedContacts);
      this.selectedContactIDs = selectedContacts.join();
      this.$router.push({
        ...this.$route,
        query: {
          modal: "is_compare_modal",
          contact_ids:selectedContacts.join()
        },
      });
    },
    onFinishedMergeCompare() {
      this.searchString = "";
      this.searchStringField = "";
      this.contacts = [];
    },
  },
};
</script>

<style lang="scss">
.cmp-contacts-import_export-merge_contact {
  .contact-type-selection {
    .contact-type:first-child {
      margin-top: 0px;
    }
    .contact-type:last-child {
      margin-bottom: 0px;
    }
    margin-bottom: 30px;
  }
}

// .search {
//   padding: 10px 0 10px 10px !important;
// }
// .cb-filters {
//   padding: 5px 10px !important;
// }
// .cb-flex {
//   padding-top: 5px;
// }

// .checkbox-container {
//   padding: 5px 0;
// }

// .form-group .dt-dropdown {
//   margin: 5px 5px !important;
// }

// .contacts {
//   .contact-item {
//     padding: 5px;

//     .checkbox-container {
//       padding: 5px 0px;
//     }

//     &:nth-child(even) {
//       background: var(--sprt-8);
//     }
//     .contact-name {
//       cursor: pointer;
//     }
//   }
// }
</style>
